import * as THREE from 'three';

export class ResourceTracker {
  private readonly resources = new Set<THREE.Object3D | THREE.Material | THREE.Texture | THREE.BufferGeometry>();

  track<T extends THREE.Object3D | THREE.Material | THREE.Texture | THREE.BufferGeometry>(resource: T): T {
    this.resources.add(resource);
    return resource;
  }

  trackTree(root: THREE.Object3D): void {
    this.resources.add(root);
    root.traverse((object) => {
      const mesh = object as THREE.Mesh;
      if (mesh.geometry) this.resources.add(mesh.geometry);
      const materials = mesh.material ? (Array.isArray(mesh.material) ? mesh.material : [mesh.material]) : [];
      for (const material of materials) {
        this.resources.add(material);
        for (const value of Object.values(material)) {
          if (value instanceof THREE.Texture) this.resources.add(value);
        }
      }
    });
  }

  dispose(): void {
    for (const resource of this.resources) {
      if (resource instanceof THREE.Object3D) resource.removeFromParent();
      if (
        resource instanceof THREE.Material ||
        resource instanceof THREE.Texture ||
        resource instanceof THREE.BufferGeometry
      ) {
        resource.dispose();
      }
    }
    this.resources.clear();
  }
}
